"use client";

import { Badge, Button, Link } from "@spheron/ui-library";
import SpheronLogo from "@spheron/ui-library/dist/assets/spheron-specific/spheron-logo.svg";
import Arrow from "@spheron/ui-library/dist/assets/arrow-right-1.svg";
import MailIcon from "@spheron/ui-library/dist/assets/sms.svg";

const RENT_GPU_URL =
  "https://app.spheron.ai?utm_source=fizz-node&utm_medium=referral&utm_campaign=fizz-node-phase-out&utm_content=phase-out-cta&ref=fizz-node";
const CONTACT_EMAIL = "info@spheron.network";

const PhaseOut = () => {
  return (
    <div className="lg:px-14 px-4 max-w-[1400px] mx-auto">
      <div className="min-h-[calc(100vh-220px)] flex items-center justify-center py-16">
        <div
          className="relative w-full max-w-[640px] overflow-hidden rounded-2xl
            border border-base-border dark:border-dark-base-border
            bg-base-fg dark:bg-dark-base-fg
            px-6 py-12 sm:px-12 sm:py-14 text-center"
        >
          {/* Soft top glow to keep it on-brand without adding noise */}
          <div
            aria-hidden
            className="pointer-events-none absolute inset-x-0 -top-24 h-48
              bg-skynet-gradient opacity-60"
          />

          <div className="relative flex flex-col items-center gap-y-6">
            <div
              className="flex h-16 w-16 items-center justify-center rounded-2xl
                border border-base-border dark:border-dark-base-border
                bg-base-bg dark:bg-dark-base-bg"
            >
              <SpheronLogo className="h-9 w-9 text-logo-primary dark:text-dark-logo-primary" />
            </div>

            <Badge
              text="Fizz Node · Sunset"
              size="medium"
              solid={false}
              badgeType="warning"
            />

            <div className="flex flex-col gap-y-3">
              <h1
                className="text-2xl sm:text-[32px] font-semibold leading-tight
                  text-base-heading-text-color dark:text-dark-base-heading-text-color"
              >
                We&apos;re phasing out Fizz Node
              </h1>
              <p
                className="text-sm sm:text-base leading-6 max-w-[480px] mx-auto
                  text-base-para-text-color dark:text-dark-base-para-text-color"
              >
                Thank you for being part of the Fizz Node journey. We&apos;ve
                decided to phase out Fizz Node and will no longer be maintaining
                it. If you&apos;re looking to rent GPUs, everything you need now
                lives on Spheron.
              </p>
            </div>

            <div className="flex flex-col items-center gap-y-4 pt-2">
              <Button
                label="Rent GPUs on Spheron"
                size="medium"
                buttonType="primary"
                rightIcon={<Arrow className="w-5 h-5" />}
                onClick={() => window.open(RENT_GPU_URL, "_blank")}
                classname="whitespace-nowrap"
              />
              <div
                className="flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1
                  text-sm text-base-sub-text-color dark:text-dark-base-sub-text-color"
              >
                <MailIcon className="w-4 h-4 text-base-icon dark:text-dark-base-icon" />
                <span>Have questions? Reach us at</span>
                <Link
                  type="primary"
                  size="default"
                  text={CONTACT_EMAIL}
                  isBold
                  onClick={() =>
                    window.open(`mailto:${CONTACT_EMAIL}`, "_self")
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhaseOut;
